export const VideoPlayerShimmerUI = () => (
  <div className="w-full h-[70vh] bg-gray-800 rounded-xl animate-pulse shadow-lg"></div>
);

export const VideoInfoShimmerUI = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 text-sm text-gray-400">
    <div className="h-8 bg-gray-700 rounded w-3/4"></div>
    <div className="h-4 bg-gray-700 rounded w-full"></div>
    <div className="h-4 bg-gray-700 rounded w-5/6"></div>
    <div className="h-4 bg-gray-700 rounded w-1/2"></div>
    <div className="h-4 bg-gray-700 rounded w-full"></div>
    <div className="h-4 bg-gray-700 rounded w-full"></div>
    <div className="h-4 bg-gray-700 rounded w-3/4"></div>
    <div className="h-4 bg-gray-700 rounded w-3/4"></div>
    <div className="h-4 bg-gray-700 rounded w-2/3"></div>
  </div>
);
